export default __webpack_public_path__ + "static/media/PanCardImagePlaceHolder.dedc2f6f.png";